import type { Operation } from "./types"

export const SEND_OPERATIONS_REQUESTED = "operations/send/requested"

export const sendOperationsRequested = (operations: Operation[]) => ({
    type: SEND_OPERATIONS_REQUESTED,
    payload: {
        operations: operations,
    },
})

export const SEND_OPERATIONS_SUCCESS = "operations/send/success"

export const sendOperationsSuccess = (operations: Operation[]) => ({
    type: SEND_OPERATIONS_SUCCESS,
    payload: {
        operations: operations,
    },
})

export const SEND_OPERATIONS_FAILURE = "operations/send/failure"

export const sendOperationsFailure = (error?: any) => ({
    type: SEND_OPERATIONS_FAILURE,
    payload: {
        error: error,
    },
})

export const SEND_OPERATIONS_CLEAR_STATE = "operations/send/clearState"

export const sendOperationsClearState = () => ({
    type: SEND_OPERATIONS_CLEAR_STATE,
})
